import { CloudRepository } from "./CloudRepository";

let _cloudRepository = CloudRepository.Main;

export const getCloudRepository = () => _cloudRepository;

export const isPreloaded = (componentId: string, env?: string, preview?: boolean): boolean => {
    return _cloudRepository.isPreloaded(componentId, env, preview);
};

export const getPreloadedParams = (componentId: string) => {
    return _cloudRepository.getPreloadedParams(componentId);
};

export const enableLocalDev = () => {
    _cloudRepository = new CloudRepository("http://localhost:9292");
};

export const setCloudRepositoryUrl = (url: string) => {
    _cloudRepository = new CloudRepository(url);
};

/**
 * Configure the SDK to fetch components from a self-hosted static registry (S3, CDN, etc.)
 * instead of the Myop cloud. Components are served as static JSON files:
 *   `${cdnUrl}/components/${componentId}/${environment}.json`
 */
export const enableSelfHosted = (cdnUrl: string, queryParams?: Record<string, string>) => {
    _cloudRepository = new CloudRepository(cdnUrl);
    _cloudRepository.enableStaticMode();
    if (queryParams) {
        _cloudRepository.setQueryParams(queryParams);
    }
};

export const setCloudRepository = (repository: CloudRepository) => {
    _cloudRepository = repository;
};

export const setEnvironment = (env: string) => {
    _cloudRepository.setEnvironment(env);
};

export const getResolvedConfig = (componentId: string, env?: string, preview?: boolean) => {
    return _cloudRepository.getResolvedConfig(componentId, env, preview);
};

export const preloadComponents = async (ids: string[], env?: string, preview?: boolean) => {
    return Promise.allSettled(
        ids.map((id) => _cloudRepository.fetchComponentV2(id, env, preview)),
    );
};
